import { render, staticRenderFns } from "./AppointmentsTab.vue?vue&type=template&id=1425c82e&scoped=true&"
import script from "./AppointmentsTab.vue?vue&type=script&lang=js&"
export * from "./AppointmentsTab.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsTab.vue?vue&type=style&index=0&id=1425c82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425c82e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VChip,VIcon})
